export const DefaultCalendarColor: string = '#D3D3D3';
